import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { getInitialLanguage, isSupportedLanguage, persistLanguage } from './detect';
import bcryptEn from './locales/en/bcrypt.json';
import commonEn from './locales/en/common.json';
import jwtEn from './locales/en/jwt.json';
import layoutEn from './locales/en/layout.json';
import md5En from './locales/en/md5.json';
import millisdateEn from './locales/en/millisdate.json';
import privacyEn from './locales/en/privacy.json';
import regexEn from './locales/en/regex.json';
import toolsHomeEn from './locales/en/tools-home.json';
import toolsEn from './locales/en/tools.json';
import uuidEn from './locales/en/uuid.json';
import en from './locales/en.json';
import bcryptPl from './locales/pl/bcrypt.json';
import commonPl from './locales/pl/common.json';
import jwtPl from './locales/pl/jwt.json';
import layoutPl from './locales/pl/layout.json';
import md5Pl from './locales/pl/md5.json';
import millisdatePl from './locales/pl/millisdate.json';
import privacyPl from './locales/pl/privacy.json';
import regexPl from './locales/pl/regex.json';
import toolsHomePl from './locales/pl/tools-home.json';
import toolsPl from './locales/pl/tools.json';
import uuidPl from './locales/pl/uuid.json';
import pl from './locales/pl.json';

const initialLanguage = getInitialLanguage();

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
      common: commonEn,
      layout: layoutEn,
      tools: toolsEn,
      'tools-home': toolsHomeEn,
      privacy: privacyEn,
      bcrypt: bcryptEn,
      md5: md5En,
      millisdate: millisdateEn,
      regex: regexEn,
      jwt: jwtEn,
      uuid: uuidEn,
    },
    pl: {
      translation: pl,
      common: commonPl,
      layout: layoutPl,
      tools: toolsPl,
      'tools-home': toolsHomePl,
      privacy: privacyPl,
      bcrypt: bcryptPl,
      md5: md5Pl,
      millisdate: millisdatePl,
      regex: regexPl,
      jwt: jwtPl,
      uuid: uuidPl,
    },
  },
  lng: initialLanguage,
  fallbackLng: 'pl',
  supportedLngs: ['pl', 'en'],
  ns: [
    'translation',
    'common',
    'layout',
    'tools',
    'tools-home',
    'privacy',
    'bcrypt',
    'md5',
    'millisdate',
    'regex',
    'jwt',
    'uuid',
  ],
  defaultNS: 'translation',
  fallbackNS: 'translation',
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  if (isSupportedLanguage(lng)) {
    persistLanguage(lng);
  }
});

document.documentElement.lang = i18n.resolvedLanguage ?? initialLanguage;
persistLanguage(initialLanguage);

i18n.services.formatter?.add('uppercase', (value) => value.toUpperCase());

export default i18n;
